<div class="callback-dialog">
    <div class="callback-dialog__title-row">
        <span class="callback-dialog__title-icon" aria-hidden="true">
            <app-svg-icon name="call" size="sm" class="callback-dialog__title-icon-svg" />
        </span>
        <h3 class="callback-dialog__title">{{ data.title }}</h3>
    </div>
    <p class="callback-dialog__message">{{ data.message }}</p>

    @if (data.showCommentInput) {
        <div
            class="callback-dialog__field"
            [class.callback-dialog__field--focused]="isCommentFocused()"
            [class.callback-dialog__field--filled]="comment()?.length"
            [class.callback-dialog__field--error]="showMinLengthError() || isCommentBelowMin()"
        >
            <label
                class="callback-dialog__field-label"
                [class.callback-dialog__field-label--floating]="isLabelFloating()"
                for="comment-input"
            >
                {{ data.commentLabel }}
            </label>
            <textarea
                id="comment-input"
                class="callback-dialog__textarea"
                #commentInput
                [ngModel]="comment()"
                (ngModelChange)="onCommentInput($event)"
                [ngModelOptions]="{ standalone: true }"
                name="comment"
                [placeholder]="isLabelFloating() ? data.commentPlaceholder : ''"
                [maxlength]="maxLength"
                rows="4"
                (focus)="onCommentFocus()"
                (blur)="onCommentBlur()"
            ></textarea>
        </div>
        @if (showMinLengthError() || isCommentBelowMin()) {
            <p class="callback-dialog__field-error" role="alert">{{ minLengthMessage }}</p>
        }
        <div
            class="callback-dialog__char-count"
            [class.callback-dialog__char-count--warning]="isCommentBelowMin()"
            [class.callback-dialog__char-count--near-max]="comment().length > maxLength * 0.8"
        >
            {{ comment().length }}/{{ maxLength }}
        </div>
    }

    <div class="callback-dialog__actions">
        @if (data.cancelText) {
            <div class="callback-dialog__action">
                <ei-button
                    class="callback-dialog__action-button"
                    variant="tertiary"
                    size="md"
                    fullWidth
                    [label]="data.cancelText || defaultTexts.CONFIRMATION.cancelText"
                    (buttonClick)="handleCancelClick()"
                />
            </div>
        }
        <div class="callback-dialog__action">
            <ei-button
                class="callback-dialog__action-button"
                variant="primary"
                size="md"
                fullWidth
                [label]="data.confirmText || defaultTexts.CONFIRMATION.confirmText"
                [disabled]="isConfirmDisabled()"
                (buttonClick)="handleConfirmClick()"
            />
        </div>
    </div>
</div>
